import React, { useEffect, useState } from 'react';
import Navbar from '../../Navbar/Navbar';
import { useDispatch, useSelector } from 'react-redux';
import { addNoticeDetails, fetchNoticeData, fetchNoticeDetails } from '../../../Redux/Config/Action';
import { FaEdit } from 'react-icons/fa';
import Swal from 'sweetalert2';
import NewDataTable from '../../DataTable/NewDataTable';
import "./Notice.css";


const NoticeDetails = () => {

  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const { noticeDetails, noticeDataById } = useSelector((store) => store.config);

  const [formData, setFormData] = useState({
    noticeId: "",
    notice: "",
    actionType: "INSERT"
  });

  const clearUserInputFields = () => {
    setFormData([
      {
        noticeId: "",
        notice: "",
        actionType: "INSERT"
      },
    ]);
  };

  const handleShow = () => setShow(true);

  const handleClose = () => {
    clearUserInputFields();
    setShow(false);
  };

  useEffect(() => {
    dispatch(fetchNoticeDetails(token));
  }, [dispatch, token]);



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleEdit = (noticeId) => {
    dispatch(fetchNoticeData(noticeId, token));
    setShow(true);
  };

  useEffect(() => {
    if (noticeDataById.noticeDto) {
      setFormData({
        noticeId: noticeDataById.noticeDto.noticeId || "",
        notice: noticeDataById.noticeDto.notice || "",
        actionType: "UPDATE",
      });
    }
  }, [noticeDataById.noticeDto]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      dispatch(addNoticeDetails(formData, token))
        .then((response) => {
          if (response.statusMessage === "SUCCESS") {
            dispatch(fetchNoticeDetails(token));
            handleClose();
            Swal.fire({
              title: "Success!",
              text: response.statusDesc,
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: response.statusDesc,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error initiating the notice details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }

  };


  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };


  const columns = [
    {
      name: "SN",
      cell: (_, index) => index + 1,
      sortable: false,
      width: "80px",
      align: "center",
    },
    {
      name: "Notice Details",
      selector: (row) => row?.notice || "-",
      sortable: true,
      align: "left",
    },
    {
      name: "Action",
      selector: (row) => row,
      sortable: false,
      width: "226px",
      align: "center",
      cell: (row) => (
        <div>
          {/* Edit Button with Tooltip */}
          <Tooltip text="Edit">
            <button
              type="button"
              className="btn btn-secondary btn-sm me-2"
              onClick={() => handleEdit(row.noticeId)}
            >
              <FaEdit />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];



  return (
    <div>
      <Navbar></Navbar>
      <div className="main-content">
        <div className="container-fluid mt-4">
          <div className="row mb-3 justify-content-end align-items-center">
            <div className="col-auto d-flex align-items-center">
              <button className="btn btn-primary" onClick={handleShow}>
                ADD NEW
              </button>
            </div>
          </div>
          <div className="card3">
            <div className="card-body">

              <NewDataTable
                columns={columns}
                data={noticeDetails || []}
                tableName="NOTICE DETAILS"
              />
            </div>

            {show && <div className="modal-backdrop fade show"></div>}
            <div className={`modal fade notice-modal ${show ? "show d-block" : ""}`} tabIndex="-1" role="dialog">
              <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add Notice Details</h5>
                    <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                  </div>
                  <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row mb-3">
                        <div className="col-md-12">
                          <label className="form-label">Notice Details</label>
                          <textarea
                            className="form-control"
                            rows="3"
                            name="notice"
                            value={formData.notice}
                            onChange={handleChange}
                            required
                          ></textarea>
                        </div>
                      </div>
                      <div className="text-center">
                        <button type="submit" className="btn btn-success">Submit</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};


export default NoticeDetails;